var ABSOLUTE_URL_REGEX = /^(?:[+a-z]+:)?\/\//i;
var isAbsoluteURL = function isAbsoluteURL(url) {
  return ABSOLUTE_URL_REGEX.test(url);
};

/**
 * Return a query param from a url
 * @param {string} url - A url which contains the query params.
 * @param {string} param - The param whose value is to be obtained
 * @returns {string} - Returns the value for the specified param
 */
function getParamValueFromUrl(url, param) {
  var _URL$searchParams$get;
  return (_URL$searchParams$get = new URL(url).searchParams.get(param)) !== null && _URL$searchParams$get !== void 0 ? _URL$searchParams$get : '';
}

export { getParamValueFromUrl, isAbsoluteURL };
//# sourceMappingURL=index.js.map
